import { observer } from "mobx-react";
import "./resolution-card.scss";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { Checkbox } from "../../../../../components/inputs/checkbox/checkbox";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../components/fonts/font-body3/font-body3";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";


interface IProps {
    imgSrc: string;
    title: string;
    description: string;
    disabled: boolean;
    isEnabled: boolean;
    onClick: () => void;
}

const ResolutionCard: React.FC<IProps> = observer(({imgSrc, title, description, disabled, isEnabled, onClick}: IProps) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = "dashboard-onboarding";

    return(
        <div className={`resolution-card ${disabled ? 'disabled' : ''}`} onClick={onClick}>
            {disabled &&
                <div className="resolution-card-tag">
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.UPPERCASE}>{getTranslation('NOT_INCLUDED_IN_YOUR_PLAN', scope)}</FontBody3>
                </div>
            }
            <div className="resolution-card-icon">
                <img src={imgSrc} alt="resolution icon" />
            </div>
            <div className="resolution-card-text">
                <FontHeading4 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                    {title}
                </FontHeading4>
                <FontBody2 color={FONT_COLOR.PRIMARY2}> {description} </FontBody2>
            </div>
            {!disabled &&
                <div className="resolution-card-checkbox">
                    <Checkbox label='' checked={isEnabled} disabled={disabled} onChange={onClick}/>
                </div>
            }

        </div>
    )
});

export default ResolutionCard;